import React, { useEffect, useState } from "react";
import { useDataTable } from "../../../shared/hooks/DataTable";
import { InvoiceService } from "../../hoa-don/InvoiceService";
import { InvoiceDiscountList } from "../../../service/invoice/InvoiceDiscountList";
import { useToolbar } from "../../../shared/hooks/Toolbar";
import DialogDiscountInvoiceAttachment from "./components/DialogDiscountInvoiceAttachment";
import { DialogCrup } from "../../hoa-don/component/DialogCrup";
import { TenantSettingService } from "../../he-thong/tham-so-he-thong/TenantSettingService";
import { RegisterInvoiceService } from "../../../service/invoice/RegisterInvoiceService";
import { CurrencyService } from "../../danh-muc/tien-te/CurrencyService";
import { AppStorage } from "../../../service/UserStorage";
import { ServerTimeService } from "../../../service/ServerTimeService";
import moment from "moment";
import { ConfirmDialogService } from "../../../AppConfirmDialog";
import { useSign } from "../../../shared/component/Sign";
import { Dialog } from "primereact/dialog";

const List = () => {
  const header = "Hoá đơn điều chỉnh";
  const dataKey = "id";
  const [selectInvoiceDiscounted, setSelectInvoiceDiscounted] = useState([]);
  const [
    displayDiscountInvoiceAttachment,
    setDisplayDiscountInvoiceAttachment,
  ] = useState(false);
  const [displayCrup, setDisplayCrup] = useState(null);
  const [registerInvoices, setRegisterInvoices] = useState([]);
  const [currencies, setCurrencies] = useState(null);
  const [paymentTypes, setPaymentTypes] = useState(null);
  const [registerInvoice, setRegisterInvoice] = useState(null);
  const [invoiceStatus, setInvoiceStatus] = useState(0);
  const [showIconSign, setShowIconSign] = useState(false);
  const [idInvoiceListDiscount, setIdInvoiceListDiscount] = useState(null);
  const [relatedInvoiceProperty, setRelatedInvoiceProperty] = useState(null);
  const [showIconHitoryChange, setShowIconHitoryChange] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const [displayView, setDisplayView] = useState(false);
  const [pdfSrc, setPdfSrc] = useState("");
  const {
    render: renderDataTable,
    reloadLazyData,
    selectedItems,
  } = useDataTable({
    header,
    dataKey,
    columns: [
      {
        field: "invoiceListSerial",
        header: "Kí hiệu",
        width: 110,
        matchMode: "contains",
      },
      {
        field: "invoiceListNumber",
        header: "Số bảng kê",
        width: 110,
        matchMode: "contains",
      },
      {
        field: "invoiceListDate",
        header: "Ngày bảng kê",
        width: 120,
        dataType: "date",
        matchMode: "equals",
        filterType: "date",
      },
      {
        field: "status",
        header: "Trạng thái",
        width: 100,
        matchMode: "contains",
        dataType: "custom",
        filterType: "dropdown",
        filterOptions: [
          { label: "Chờ ký", value: 0 },
          { label: "Đã ký", value: 1 },
        ],
        customCell(rowData: any): any {
          if (!rowData.status) {
            return (
              <span className="invoice-list-discount-status invoice-list-discount-status-0">
                Chờ ký
              </span>
            );
          }
          return (
            <span className="invoice-list-discount-status invoice-list-discount-status-1">
              Đã ký
            </span>
          );
        },
      },
      {
        field: "invoiceSerial",
        header: "Ký hiệu",
        width: 110,
        matchMode: "contains",
      },
      {
        field: "invoiceDate",
        header: "Ngày lập",
        width: 120,
        dataType: "date",
        matchMode: "equals",
        filterType: "date",
      },
      {
        field: "invoiceNumber",
        header: "Số hóa đơn",
        width: 100,
        dataType: "custom",
        customCell(rowData: any): any {
          const text = rowData.invoiceNumber;
          return (
            <span
              className="underline text-primary"
              onClick={() => {
                InvoiceService.getDetail(rowData.invoiceId).then((res) => {
                  setSelectedItem(res);
                  setRegisterInvoice(
                    registerInvoices.find(
                      (item) => item.id === res.registerInvoiceId,
                    ),
                  );
                });
                if (rowData.status === 0) {
                  setShowIconSign(true);
                } else {
                  setShowIconSign(false);
                }
                setDisplayCrup(true);
              }}
            >
              {text}
            </span>
          );
        },
      },
      {
        field: "buyerLegalName",
        header: "Tên đơn vị mua",
        width: 180,
        matchMode: "contains",
      },
      {
        field: "buyerTaxCode",
        header: "Mã số thuế",
        width: 150,
        matchMode: "contains",
      },
      {
        field: "buyerAddress",
        header: "Địa chỉ",
        minWidth: 200,
        matchMode: "contains",
      },
      {
        field: "creatorName",
        header: "Người tạo",
        minWidth: 200,
        matchMode: "contains",
      },
      {
        field: "creationTime",
        header: "Ngày tạo",
        width: 110,
        dataType: "date",
        matchMode: "equals",
        filterType: "date",
      },
    ],
    indexColumnWidth: 40,
    getList: (params) => {
      params.IsOtherInvoice = false;
      return InvoiceDiscountList.getList(params);
    },
    selectionMode: "single",
  });
  const { renderSign, sign } = useSign({ onComplete: reloadLazyData });
  let userName = AppStorage.get("UserName");

  const { renderToolbar, refreshToolbar } = useToolbar({
    dataKey,
    reloadLazyData,
    selectedItems,
    deleteItem: (id) => {
      return InvoiceDiscountList.delete(id);
    },
    otherActions: [
      {
        label: "Sửa",
        icon: "pi pi-fw pi-pencil",
        className: "iam-toolbar iam-toolbar-info",
        command: () => {
          setDisplayDiscountInvoiceAttachment(true);
        },
        disabled: Array.isArray(selectedItems),
      },
      {
        label: "Xem in",
        icon: "pi pi-fw pi-print",
        className: "iam-toolbar iam-toolbar-success",
        command: () => {
          if (Array.isArray(selectedItems)) {
            return;
          }
          if (
            selectedItems &&
            typeof selectedItems === "object" &&
            selectedItems !== null &&
            "id" in selectedItems
          ) {
            setPdfSrc(
              InvoiceDiscountList.getPdfUrl(
                (selectedItems as { id: string }).id,
              ),
            );
            setDisplayView(true);
          }
        },
        disabled: Array.isArray(selectedItems),
      },
      {
        label: "Tạo HĐ chiết khấu",
        icon: "pi pi-fw pi-plus",
        className: "iam-toolbar",
        // command: () => setDisplayDiscountInvoiceAttachment(true),
        command: () => {
          if (Array.isArray(selectedItems)) {
            return;
          }
          if (
            selectedItems &&
            typeof selectedItems === "object" &&
            selectedItems !== null &&
            "id" in selectedItems
          ) {
            if (!(selectedItems as { invoiceId: string })?.invoiceId) {
              setRegisterInvoice(
                registerInvoices.find(
                  (item) =>
                    item.symbolCode ===
                    ((selectedItems as { invoiceSerial?: string })
                      ?.invoiceSerial ?? ""),
                ),
              );
              setDisplayCrup(true);
              if (
                selectedItems &&
                typeof selectedItems === "object" &&
                selectedItems !== null
              ) {
                setIdInvoiceListDiscount({
                  ...(selectedItems as Record<string, any>),
                  invoiceDate: new Date(),
                });
              } else {
                setIdInvoiceListDiscount({ invoiceDate: new Date() });
              }
              setShowIconSign(true);
              return;
            }
            ConfirmDialogService.showInvalid(
              "Bạn không thể tạo HĐ do bảng kê đã được tạo trước đó",
            );
          }
        },
        disabled: Array.isArray(selectedItems),
      },
    ],
  });

  const handleSign = async (plugCommand) => {
    const { InvoiceIdArray } = plugCommand;

    if (!InvoiceIdArray[0].signOnly) {
      const serverTime = await ServerTimeService.getList({});
      const time = moment(serverTime.time);
      const invoiceDate = moment(InvoiceIdArray[0].invoiceDate);
      const diffInDays = time.diff(invoiceDate, "days");
      if (diffInDays >= 2) {
        ConfirmDialogService.setProps({
          className: "w-6",
          message: (
            <div>
              Theo quy định tại Điểm c Khoản 7 và Điểm b Khoản 14, Điều 1, Nghị
              định 254/2026/NĐ-CP, thời điểm ký gửi dữ liệu hóa đơn lên CQT chậm
              nhất là ngày làm việc tiếp theo kể từ thời điểm lập hóa đơn. Hóa
              đơn đang ký có ngày lập <b>{invoiceDate.format("DD/MM/YYYY")}</b>,
              ký hiệu <b>{InvoiceIdArray[0].invoiceSerial}</b>, số{" "}
              <b>{InvoiceIdArray[0].invoiceNumber}</b> không thỏa mãn quy định
              trên. Bạn có muốn tiếp tục thao tác ký gửi không?
            </div>
          ),
          header: "Cảnh báo ký gửi hóa đơn sai thời điểm",
          icon: "pi pi-info-circle",
          acceptClassName: "p-button-danger",
          acceptLabel: "Có, tiếp tục ký",
          rejectLabel: "Không",
          accept: () => {
            sign({
              CommandName: "SignInvoices",
              InvoiceIdArray: [InvoiceIdArray[0].id],
            });
          },
        });
        return;
      }
    }
    sign({
      CommandName: "SignInvoices",
      InvoiceIdArray: [InvoiceIdArray[0].id],
    });
  };

  useEffect(() => {
    TenantSettingService.getList({
      key: TenantSettingService.key.BAT_LUU_LICH_SU_THAY_DOI_HOA_DON,
    })
      .then(({ items, totalCount }) => {
        if (totalCount > 0) {
          setShowIconHitoryChange(items[0].value === "C");
        }
      })
      .finally(() => {
        RegisterInvoiceService.getUsingList({
          maxResultCount: 1000,
          userName,
          Sorting: "creationTime",
          SortType: "DESCEND",
        }).then(({ items }) => {
          const _registerInvoices = [];
          items.forEach((item) => {
            item.label = `${item.symbolCode} - ${item.invoiceTypeName}`;
            _registerInvoices.push(item);
          });
          setRegisterInvoices(_registerInvoices);
        });
        CurrencyService.getList({ maxResultCount: 1000 }).then(({ items }) => {
          setCurrencies(items);
        });
        InvoiceService.getPaymentTypes().then(({ items }) => {
          const _paymentTypes = [];
          items.forEach((item) => {
            _paymentTypes.push({ value: item.name, label: item.name });
          });
          setPaymentTypes(_paymentTypes);
        });
      });
  }, []);

  useEffect(() => {
    refreshToolbar();
  }, [selectedItems]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <>
      {renderToolbar()}
      {renderDataTable()}
      {renderSign()}
      <DialogDiscountInvoiceAttachment
        display={displayDiscountInvoiceAttachment}
        setInvoices={setSelectInvoiceDiscounted}
        setDisplay={setDisplayDiscountInvoiceAttachment}
        selectedItems={selectedItems}
        reloadLazyData={reloadLazyData}
      />
      <DialogCrup
        display={displayCrup}
        setDisplay={setDisplayCrup}
        reloadLazyData={reloadLazyData}
        registerInvoices={registerInvoices}
        currencies={currencies}
        paymentTypes={paymentTypes}
        registerInvoice={registerInvoice}
        selectedItem={selectedItem}
        invoiceStatus={invoiceStatus}
        setInvoiceStatus={setInvoiceStatus}
        sign={handleSign}
        showIconSign={showIconSign}
        showSave={showIconSign}
        idInvoiceListDiscount={idInvoiceListDiscount}
        setSelectedItems={setSelectedItem}
        setDisplayDiscountInvoiceAttachment={
          setDisplayDiscountInvoiceAttachment
        }
        relatedInvoiceProperty={5}
        setRelatedInvoiceProperty={setRelatedInvoiceProperty}
        setIdInvoiceListDiscount={setIdInvoiceListDiscount}
      />
      <Dialog
        visible={displayView}
        onHide={() => setDisplayView(false)}
        style={{ width: "80%", height: "100%" }}
        header="Xem in"
      >
        {pdfSrc && (
          <iframe
            src={pdfSrc}
            width="100%"
            height="100%"
            style={{ border: "none" }}
            title="pdf-preview"
          />
        )}
      </Dialog>
    </>
  );
};

export default List;
